<template>
  <b-container>
    <ResourceList :data="data" :is-deleting="isDeleting" :is-loading="isLoading" :pagination="pagination"
                  :search-query="$route.query.query"
                  can-delete create-to="dash.payments.create" resource="payment" soft-deletes
                  title="Payments" @paginate="onPaginate" @search="onSearch"
                  @delete-many="onDeleteMany">
      <template #listItem="{ item }">
        <div class="d-flex flex-column flex-fill">
          <div class="d-flex flex-row flex-fill">
            <p class="h5 flex-fill mb-1 text-primary">
              <router-link :to="{ name: 'dash.payments.view', params: { id: item.id } }" class="text-dark">#{{ item.id
                }} {{ item.order.customer.name }}
              </router-link>
            </p>
            <p class="align-self-end mb-1 text-muted">
              <FriendlyDate :date="item.created_at"/>
            </p>
          </div>
          <div class="d-flex flex-row flex-fill mb-0 mb-md-1">
            <p class="mb-0">Order ID: {{ item.order.id }}</p>
          </div>
          <div class="d-flex flex-row flex-fill mb-0 mb-md-1">
            <b-button v-b-popover.hover.bottom="'View more information about this payment.'"
                      :to="{ name: 'dash.payments.view', params: { id: item.id } }" class="mr-1 mb-0"
                      size="sm"
                      variant="primary">
              <b-icon icon="eye"/>
              View
            </b-button>
          </div>
        </div>
      </template>
    </ResourceList>
  </b-container>
</template>
<script>
import ResourceList from "../../components/ResourceList"
import currentUser from "../../mixins/currentUser"
import {mapActions, mapGetters} from "vuex"
import FriendlyDate from "../../components/FriendlyDate"

export default {
  mixins: [currentUser],
  created() {
    this.fetchMany(this.$route.query)
  },
  components: {
    ResourceList,
    FriendlyDate,
  },
  computed: {
    ...mapGetters("payments", ["data", "isDeleting", "isLoading", "pagination"]),
  },
  methods: {
    ...mapActions("payments", ["deleteMany", "fetchMany"]),
    async onDeleteMany({ids, modalId}) {
      await this.deleteMany({ids})
      this.$bvModal.hide(modalId)
      await this.fetchMany(this.$route.query)
    },
    async onPaginate(page) {
      if (this.$route.query.page !== page) {
        await this.$router.replace({name: this.$route.name, query: {...this.$route.query, page}}).catch(() => {
        });
        await this.fetchMany({...this.$route.query, page}).catch(() => {
        });
      }
    },
    async onSearch(query) {
      if (this.$route.query.page !== query) {
        const path = {name: this.$route.name, query: {...this.$route.query, query}};
        await this.$router.push(path).catch(() => {
        });
      }
      await this.fetchMany({...this.$route.query, query}).catch(() => {
      })
    },

  },
}
</script>
<style>
</style>
